import {
    CONTRACT_SERVICE_ENTRY_NEW_CHAT_PARAM,
    CONTRACT_SERVICE_ENTRY_PRODUCT_PARAM,
    type ContractServiceEntryProduct,
} from '@allibee/service/business-agent/shared/lnb-service-bar/serviceBarPolicy';

type ServiceEntryLauncher = Pick<MtmLauncherDto, 'tenantId' | 'workspaceId'>;

const SERVICE_ENTRY_PRODUCTS = new Set<ContractServiceEntryProduct>(['LEGAL_AGENT', 'CLM', 'ELM']);

const SERVICE_ENTRY_PRODUCT_PATHS: Record<ContractServiceEntryProduct, string> = {
    LEGAL_AGENT: '/[workspaceName]/business-agent/agent/',
    CLM: '/[workspaceName]/clm/home/',
    ELM: '/[workspaceName]/elm/home/',
};

function makeWorkspaceName({ tenantId, workspaceId }: ServiceEntryLauncher): string {
    return `${tenantId}-${workspaceId}`;
}

function parseServiceEntryProduct(searchParams: URLSearchParams): ContractServiceEntryProduct | null {
    const entryProduct = searchParams.get(CONTRACT_SERVICE_ENTRY_PRODUCT_PARAM);
    if (SERVICE_ENTRY_PRODUCTS.has(entryProduct as ContractServiceEntryProduct)) {
        return entryProduct as ContractServiceEntryProduct;
    }

    return null;
}

export function resolveServiceEntryLauncherPath(launcher: ServiceEntryLauncher, searchParams: URLSearchParams): string {
    const workspaceName = makeWorkspaceName(launcher);
    const entryProduct = parseServiceEntryProduct(searchParams);

    if (!entryProduct) return `/${workspaceName}/`;

    const path = SERVICE_ENTRY_PRODUCT_PATHS[entryProduct].replace('/[workspaceName]', `/${workspaceName}`);
    const newChat = searchParams.get(CONTRACT_SERVICE_ENTRY_NEW_CHAT_PARAM);

    if (entryProduct !== 'LEGAL_AGENT' || !newChat) return path;

    const productSearchParams = new URLSearchParams();
    productSearchParams.set(CONTRACT_SERVICE_ENTRY_NEW_CHAT_PARAM, newChat);

    return `${path}?${productSearchParams.toString()}`;
}
